// extracted by mini-css-extract-plugin
module.exports = {"container":"angels_container__hg7MI","searchGroup":"angels_searchGroup__Pdo8w","content":"angels_content__1LqvD","button":"angels_button__3EosP","sending":"angels_sending__Z6SwN"};